import React from "react";
import { RelatedProductsLoaderSerializer } from "web/types/serializers";
import { useRothko } from "web/react/hooks/use-rothko/use-rothko";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import RelatedProductsArea from "web/react/components/related-products-area/related-products-area";
import styles from "./related-products-loader.css";

const ENDPOINT = "modules/product/related_products_loader";

function RelatedProductsLoader({
    product_slug: productSlug,
    is_overlay: isOverlay,
    is_instock: isInStock,
    is_affiliate: isAffiliate,
}: RelatedProductsLoaderSerializer): React.ReactElement {
    const { data, isFetching } = useRothko<RelatedProductsLoaderSerializer>(ENDPOINT, {
        isOverlay: isOverlay.toString(),
        isInstock: isInStock.toString(),
        isAffiliate: isAffiliate.toString(),
        slug: productSlug,
    });

    const relatedProducts = data?.related_products;

    if (isFetching || !relatedProducts) {
        return (
            <div className={styles.loading}>
                <LoadingSpinner inline={true} type={"highlight"} />
            </div>
        );
    }

    return (
        <RelatedProductsArea
            sections={relatedProducts.sections}
            has_in_stock={relatedProducts.has_in_stock}
            features={relatedProducts.features}
            tabs_enabled={relatedProducts.tabs_enabled}
        />
    );
}

export default RelatedProductsLoader;
